// The education choices: the short code is what is saved (so filters and old profiles keep working), the full name is what people read.
const FULL_NAMES = {
    '10th': '10th (SSLC / Secondary School)',
    '12th': '12th (HSC / Higher Secondary)',
    'Diploma': 'Diploma',
    'Advance Diploma': 'Advance Diploma',
    'B.A': 'B.A (Bachelor of Arts)',
    'B.Sc': 'B.Sc (Bachelor of Science)',
    'B.Com': 'B.Com (Bachelor of Commerce)',
    'B.E/B.Tech': 'B.E / B.Tech (Bachelor of Engineering / Technology)',
    'BCA': 'BCA (Bachelor of Computer Applications)',
    'BBA': 'BBA (Bachelor of Business Administration)',
    'M.A': 'M.A (Master of Arts)',
    'M.Sc': 'M.Sc (Master of Science)',
    'M.Com': 'M.Com (Master of Commerce)',
    'M.E/M.Tech': 'M.E / M.Tech (Master of Engineering / Technology)',
    'MCA': 'MCA (Master of Computer Applications)',
    'MBA': 'MBA (Master of Business Administration)',
    'Ph.D': 'Ph.D (Doctor of Philosophy)',
    'Other': 'Other',
};
export const educationLabel = (code) => FULL_NAMES[code] || code;
export const EDUCATION_OPTIONS = Object.keys(FULL_NAMES).map(value => ({ value, label: FULL_NAMES[value] }));
